module.exports = __webpack_public_path__ + "assets/img/bank.812674fe.png";